{
  "fr": {
    "task_assignment": {
      "actions": {
        "confirm": "Marquer comme terminé",
        "create": "Tâche",
        "move_to_draft": "Remettre en brouillon",
        "reopen": "Rouvrir",
        "send_and_notify": "Envoyer et notifier"
      },
      "assignee_types": {
        "customer": "Client",
        "employee": "Employé",
        "partner": "Partenaire"
      },
      "attributes": {
        "assignee": "Personne assignée",
        "assignees": "Personnes assignées",
        "created_at": "Créé",
        "due_date": "Échéance",
        "project": "Projet",
        "status": "Statut",
        "task": "Tâche",
        "unit": "Unité"
      },
      "confirm": {
        "affected": "Cela concerne {customers} et {team}.",
        "affected_customers": "Cela concerne {customers}.",
        "affected_team": "Cela concerne {team}.",
        "complete_body": "Leurs tâches sont clôturées pour eux et disparaissent de leur liste, même s'ils n'ont rien fait.",
        "complete_header": "Clôturer cette tâche pour tout le monde ?",
        "customer_tasks": "{count} tâche client | {count} tâches client",
        "draft_body": "La tâche disparaît jusqu'à ce qu'elle soit renvoyée. Les e-mails déjà partis restent envoyés.",
        "draft_header": "Remettre cette tâche en brouillon ?",
        "send_customers": "Les clients voient la tâche tout de suite dans leur portail et reçoivent une notification.",
        "send_header": "Envoyer aux destinataires ?",
        "send_permanent": "L'envoi est définitif. Remettre la tâche en brouillon plus tard n'annule pas la notification.",
        "send_status": "Elles passent à Demandé.",
        "send_team": "Les membres de l'équipe sont prévenus.",
        "team_tasks": "{count} tâche d'équipe | {count} tâches d'équipe"
      },
      "labels": {
        "add_assignee": "Ajouter une personne assignée…",
        "add_customers": "Ajouter des clients",
        "already_assigned": "Cette tâche est déjà ajoutée à cette unité.",
        "already_assigned_project": "Cette tâche est déjà ajoutée à ce projet.",
        "completed": "Terminées",
        "confirm_message": "Voulez-vous vraiment marquer cette tâche comme terminée ?",
        "customers": "Clients",
        "my_tasks": "Mes tâches",
        "no_assignees": "Aucune personne assignée pour le moment.",
        "no_assignments": "Aucune tâche pour le moment.",
        "no_assignments_task": "Aucune assignation pour cette tâche pour le moment.",
        "no_assignments_unit": "Aucune tâche pour cette unité pour le moment.",
        "required": "Ce champ est obligatoire",
        "select_task": "Sélectionner une tâche",
        "upload_hint": "Téléversez le ou les documents demandés pour terminer cette tâche.",
        "uploaded_documents": "Documents téléversés"
      },
      "statuses": {
        "completed": "Terminé",
        "draft": "Brouillon",
        "requested": "Demandé"
      },
      "toasts": {
        "completed": "Tâche terminée",
        "create": "Tâche créée",
        "delete": "Tâche supprimée",
        "reopened": "Tâche rouverte",
        "update": "Tâche mise à jour"
      }
    }
  }
}
